/* The study-hours board, in the room's right column. */
.board {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.title {
  margin: 0;
  font-size: var(--text-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-subtle);
}

.tabs {
  display: flex;
  gap: 0.125rem;
  padding: 0.125rem;
  background: var(--bg-sunken);
  border-radius: var(--radius);
}

.tab {
  flex: 1;
  padding: 0.3rem 0;
  background: none;
  border: none;
  border-radius: calc(var(--radius) - 2px);
  font: inherit;
  font-size: var(--text-xs);
  color: var(--text-muted);
  cursor: pointer;
}

.tabActive {
  background: var(--indigo);
  color: #fff;
  font-weight: 600;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.row {
  display: grid;
  grid-template-columns: 1.5rem minmax(0, 1fr) auto;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2);
  border-radius: var(--radius);
}

/* The viewer's own line, so the board is a position and not a notice. */
.rowMe {
  background: var(--indigo-soft);
}

/* Pinned under the list when they are off the end of the page. */
.pinned {
  margin-top: var(--space-2);
  border-top: 1px solid var(--border);
  border-radius: 0 0 var(--radius) var(--radius);
}

.rank {
  font-size: var(--text-sm);
  color: var(--text-muted);
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.name {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: var(--text-sm);
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.youTag {
  background: var(--indigo);
  color: #fff;
  border-radius: var(--radius-full);
  padding: 0 0.375rem;
  font-size: var(--text-xs);
  font-weight: 600;
}

.figures {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0;
}

/* The hours that earned the points: context, not the ranking. */
.subFigure {
  font-size: var(--text-xs);
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.hours {
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--text);
  font-variant-numeric: tabular-nums;
}

.live {
  font-size: var(--text-xs);
  font-weight: 600;
  color: var(--success);
}

.muted {
  margin: 0;
  font-size: var(--text-sm);
  color: var(--text-muted);
}
